module.exports = __webpack_public_path__ + "static/media/Avatars_Female-20.0c1a8a28.png";